import { getSafeRandomNumber } from '@dealstack/frontend/shared/other/react/random';

import { EVENT_TOPICS } from './topic';

export { EVENT_TOPICS } from './topic';

type EventManagerEntry = { type: string; fn: () => void };
const functionMapper = new Map<string, EventManagerEntry>();

const register = (type: EVENT_TOPICS | string, fn: () => void) => {
	const id = `${type}__${Date.now()}__${getSafeRandomNumber()}`;
	functionMapper.set(id, { type, fn });
	window.addEventListener(type, fn);
	return unregister.bind(this, id);
};

const unregister = (id: string) => {
	const result = functionMapper.get(id);
	if (!result) {
		return;
	}
	window.removeEventListener(result.type, result.fn);
	functionMapper.delete(id);
};
const emit = (type: EVENT_TOPICS | string, detail?: unknown) => {
	window.dispatchEvent(new CustomEvent(type, { detail }));
};

const unregisterAll = (filter: (EventManagerEntry) => boolean = () => true) => {
	for (const [id, data] of functionMapper) {
		if (filter(data)) {
			window.removeEventListener(data.type, data.fn);
			functionMapper.delete(id);
		}
	}
};

export const eventManager = { emit, register, unregister, unregisterAll };
